import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CourseService } from 'src/app/services/course.service';

@Component({
  selector: 'app-add-module',
  templateUrl: './add-module.component.html',
  styleUrls: ['./add-module.component.scss']
})
export class AddModuleComponent implements OnInit {

  constructor(public courseService: CourseService, private router: Router, private toastrService: ToastrService) { }

  public moduleForm:FormGroup;
  public materials:any[] = [];
  public isUpdate:boolean = false;
  public responseBody:any = {};
  public courseId:any;
  public moduleId:any;
  public quizId: any;
  public fileName:any="No file chosen";
  public disableQuizBtn:boolean = true;
  public isLoading:boolean = false;


  ngOnInit(): void {
    this.moduleForm = new FormGroup({
      title: new FormControl('', Validators.required),
      description: new FormControl('', Validators.required),
      material:new FormControl([]),
      serialNo: new FormControl('', Validators.required),
      duration: new FormControl('', Validators.required)
    })
    let url = this.router.url.split('/');
    this.courseId = url[2];
    if(url.includes('modify')){
      this.isUpdate = true;
      this.moduleId = url[4];
      this.disableQuizBtn = false;
      this.courseService.getModule(url[2], url[4]).subscribe(
        (res:any)=>{
          this.responseBody['title']=res.title;
          this.responseBody['description']=res.description;
          this.responseBody['material']=res.material;
          this.responseBody['serialNo']=res.serialNo;
          this.responseBody['duration']=res.duration;
          this.quizId = res?.quiz?._id;
          this.moduleForm.patchValue(this.responseBody);
          if(res.material.length > 1){
            this.fileName = res?.material[0]?.originalname + ', ...pdf';
          }
          else {
            this.fileName = res?.material[0]?.originalname;
          }
        }
      )
    }
  }

  onFileUpload(event){
    if(event.target.files){
      if(event.target.files.length > 1)
        this.fileName = event.target.files[0].name + ', ...pdf';
      else
        this.fileName = event.target.files[0].name;
      this.moduleForm.get('material').setValue(event.target.files);
    }
  }

  onCreateModule(){
    let data = this.onCreateFormData();
    this.isLoading = true;
    if(data){
      this.courseService.addModule(this.onCreateFormData(), this.courseId).subscribe(
        (res:any)=>{
          this.isLoading = false;
          this.disableQuizBtn = false;
          this.moduleId = res.id;
          this.quizId = res.module.quiz;
          this.toastrService.success('Module added!');
          this.onClickCancel();
        }
      )
    }
  }

  onUpdateModule(){
    let data = this.onCreateFormData();
    this.isLoading = true;
    if(data){
      this.courseService.updateModule(this.onCreateFormData(),this.courseId, this.moduleId).subscribe(
        (res:any)=>{
          this.isLoading = false;
          this.disableQuizBtn = false;
          this.moduleId = res?.module._id;
          this.quizId = res?.module?.quiz?._id;
          this.onClickCancel();
          this.toastrService.success('Module updated!');
        }
      )
    }

  }

  onUpdateQuiz(){
    this.router.navigate([`courses/${this.courseId}/modules/${this.moduleId}/quiz/${this.quizId}/modify`]);
  }

  onCreateFormData(){
    if(this.moduleForm.valid){
      let {title, description, material, serialNo, duration} = this.moduleForm.value;
      let formData = new FormData();
      formData.append('title', title);
      formData.append('description', description);
      formData.append('serialNo', serialNo);
      formData.append('duration', duration);
      for(let i=0;i<material.length;i++){
        formData.append('material', material[i]);
      }
      return formData;
    }
    else {
      this.isLoading = false;
      this.toastrService.error('Please fill all the field!');
      return '';
    }
  }

  onClickCancel(){
    this.router.navigate(['admin/courses']);
  }

}
